






















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Popup from '@/components/default/Popup.vue';

import DxForm, { DxLabel, DxSimpleItem } from 'devextreme-vue/form';
import { CreateTunnelGroupCommand, UpdateTunnelGroupCommand, TunnelGroupsClient } from '@/data/web-api-client';
import { update } from 'lodash';
import { TranslateResult } from 'vue-i18n';
import notificationService from '@/services/notificationService';

@Component({
  components: {
    Popup,

    DxForm,
    DxSimpleItem,
    DxLabel,
  },
})
export default class UpsertTunnelGroupsDialog extends Vue {
  @Prop()
  show!: boolean;

  @Prop()
  existingTunnelGroup: UpdateTunnelGroupCommand | undefined;

  @Prop()
  existingPriorities!: number[];

  saving = false;

  numberBoxOptions = {
    step: 0,
  };

  priorityBoxOptions = {
    step: 0,
    onValueChanged: (e: any) => {
      if (this.prioritiesList.includes(e.value)) {
        notificationService.showErrorMessage('Prioriteit moet uniek zijn. Deze Prioriteit is al in gebruik.');
      }
    },
  };

  formData = {
    name: '',
    materialMargin: 0,
    labourMargin: 0,
    priority: 0,
  };

  existingId: string | undefined;
  dialogTitle: TranslateResult = this.$t('object.tunnelGroups.create');

  private tunnelGroupsClient: TunnelGroupsClient = new TunnelGroupsClient(undefined, this.$axios);

  async save() {
    try {

      if (this.prioritiesList.includes(this.formData.priority)) {
        notificationService.showErrorMessage('Prioriteit moet uniek zijn. Deze Prioriteit is al in gebruik.');
        return;
      }
      if (this.existingId != undefined) {
        const updateCommand = new UpdateTunnelGroupCommand(this.formData);
        updateCommand.id = this.existingId;

        const result = await this.tunnelGroupsClient.update(this.existingId, updateCommand);
      } else {
        const command = new CreateTunnelGroupCommand(this.formData);

        const result = await this.tunnelGroupsClient.create(command);
      }
      this.hide();
    } catch (err) {
    } finally {
      this.saving = false;
    }
  }

  get prioritiesList() {
    let prioritiesList = [...this.existingPriorities];
    if (this.existingTunnelGroup) {
      const currentPriorityIndex = prioritiesList.indexOf(this.existingTunnelGroup!.priority!);
      prioritiesList.splice(currentPriorityIndex, 1);
    }

    return prioritiesList;
  }

  hide() {
    this.$emit('close');
  }

  @Watch('show')
  onShowChanged() {
    if (this.existingTunnelGroup != null) {
      this.existingId = this.existingTunnelGroup.id;
      this.formData = {
        name: this.existingTunnelGroup.name!,
        materialMargin: this.existingTunnelGroup.materialMargin!,
        labourMargin: this.existingTunnelGroup.labourMargin!,
        priority: this.existingTunnelGroup.priority!,
      };

      this.dialogTitle = this.$t('object.tunnelGroups.edit');
    } else {
      this.existingId = undefined;

      this.formData = {
        name: '',
        materialMargin: 0,
        labourMargin: 0,
        priority: 0,
      };
      this.dialogTitle = this.$t('object.tunnelGroups.create');
    }
  }
}
